// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"41c25dcc","530":"057153a6","589":"d057af21","678":"801c434d"}[chunkId] + ".chunk.js";
};